import {Payload} from '../../../../../../../../core/service/payload/payload';
import {
    EmailContentPayload
} from '../../../../../../../../communication/configuration/api/payload/emailContent.payload';
import {
    WorkflowTriggerPayload
} from "../../../../../../../../workflow/task/impl/service/payload/workflowTrigger.payload";

export class SaleInvoiceSendByEmailPayload implements Payload {
    id: number;
    emailContent: EmailContentPayload;
    trigger: WorkflowTriggerPayload;
}
